import { render, staticRenderFns } from "./PullNew.vue?vue&type=template&id=062f7f2e"
import script from "./PullNew.vue?vue&type=script&lang=js"
export * from "./PullNew.vue?vue&type=script&lang=js"
import style0 from "./PullNew.vue?vue&type=style&index=0&id=062f7f2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports